import { MicrophoneIcon, CheckBox, DocumentFileIcon } from '@room-match/shared-ui-components';
import React, { useEffect, useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { IMediumAttributes } from 'shared/interfaces/IMedium';
import { AudioItemCont, AudioInfo, AudioName, Duration } from './AudioItem.styles';

interface Props {
  item: IMediumAttributes;
}

const AudioItem: React.FC<Props> = ({ item: aud }) => {
  // const audioRef = useRef(new Audio(src || SRC));
  const [audio] = useState(new Audio(aud.attachment));
  const [duration, setduration] = useState(0);
  const [playing, setplaying] = useState(false);

  useEffect(() => {
    const getAudioInfo = (e: any) => {
      setduration(e.target.duration);
    };

    const onEnded = () => {
      setplaying(false);
    };

    audio.addEventListener('loadedmetadata', getAudioInfo);
    audio.addEventListener('ended', onEnded);

    return () => {
      audio.pause();
      audio.removeEventListener('loadedmetadata', getAudioInfo);
      audio.removeEventListener('ended', onEnded);
    };
  }, [audio, aud]);

  const handleClick = () => {
    if (aud.medium.file_type.toLocaleLowerCase() !== 'audio') return window.open(`${aud.attachment}`, '_blank');
    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setplaying(!playing);
  };

  return (
    <AudioItemCont>
      {aud.medium.file_type.toLocaleLowerCase() !== 'audio' ? <DocumentFileIcon /> : <MicrophoneIcon />}
      <AudioInfo onClick={handleClick}>
        <AudioName>{aud.tag_list[0]}</AudioName>
        {aud.medium.file_type.toLocaleLowerCase() === 'audio' && (
          <Duration>
            {playing ? (
              'Playing...'
            ) : (
              <>
                {`${'Duration : '}`}
                {duration === 0
                  ? '--:--'
                  : duration < 3600
                    ? new Date(duration * 1000).toISOString().substring(14, 19)
                    : new Date(duration * 1000).toISOString().substr(11, 8)}
              </>
            )}
          </Duration>
        )}
      </AudioInfo>
    </AudioItemCont>
  );
};

export default AudioItem;
